<template>
  <div>
    <div class="text-muted mb-3">Selecione 2 alternativas. A que mais e a que menos te define.</div>
    <table>
      <tr>
        <th width="120"></th>
        <th width="70">Mais</th>
        <th width="70">Menos</th>
      </tr>
      <tr
        v-for="(option, index) in options"
        :key="index">
        <td>
          {{ option.title }}
        </td>
        <td>
          <input
            ref="input"
            type="radio"
            :checked="val[0] === option.title"
            @click="setItem(option.title, 'most')">
        </td>
        <td>
          <input
            ref="input"
            type="radio"
            :checked="val[1] === option.title"
            @click="setItem(option.title, 'least')">
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'Checkbox',
  props: {
    value: {
      type: Array,
      default: () => { return [] }
    },
    options: {
      type: Array,
      default: () => { return [] }
    }
  },
  data () {
    return {
      val: []
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    setItem (term, type) {
      const num = { 'most': 0, 'least': 1 }[type]

      this.val = this.val.map(item => {
        return item === term ? null : item
      })
      this.val[num] = term

      if (this.val.filter(v => v).length === 2) {
        this.$emit('input', this.val)
      } else {
        this.$emit('input', [])
      }
    }
  }
}
</script>

<style scoped>
</style>
